import AgentChatManager from '@src/logic/agentchatmanager';
import PickupError from '@src/logic/errors/pickupError';
import { selectChatActions } from '@src/selectors/chats';
import type { RootState } from '@src/store/reduxstore';
import { ChatActionType, ChatActionsStatus } from '@src/types/chats';
import { useCallback } from 'react';
import { useStore } from 'react-redux';

const useChatPickupAsync = () => {
  const store = useStore<RootState>();

  const pickupChatAsync = useCallback(
    (chatId: string, agentId: number, timeout = 12_000): Promise<void> =>
      new Promise((resolve, reject) => {
        let unsubscribe: (() => void) | null = null;
        let timeoutId: NodeJS.Timeout | null = null;

        const cleanup = () => {
          if (!unsubscribe) return;
          unsubscribe();
          unsubscribe = null;

          if (!timeoutId) return;
          clearTimeout(timeoutId);
          timeoutId = null;
        };

        // Suscribirse a cambios del store
        unsubscribe = store.subscribe(() => {
          const state = store.getState();
          const actionChat = selectChatActions(state);

          if (actionChat && actionChat?.type === ChatActionType.PICKUP_CHAT) {
            if (actionChat.status === ChatActionsStatus.AWAIT) return;

            cleanup();
            if (actionChat.status === ChatActionsStatus.SUCCESS) resolve();

            if (actionChat.status === ChatActionsStatus.FAILURE)
              reject(new PickupError('Chat pickup failed'));
          }
        });

        timeoutId = setTimeout(() => {
          cleanup();
          resolve();
        }, timeout);

        try {
          AgentChatManager.requestChatPickup(chatId, agentId, true);
        } catch (error) {
          cleanup();
          reject(new PickupError());
        }
      }),
    [store]
  );

  return pickupChatAsync;
};

export default useChatPickupAsync;
